import { useMemo } from 'react';

import { CompaniesApiFactory } from '@/api/generated/apis/companies-api';
import { CompaniesSearchRestApiFactory } from '@/api/generated/apis/companies-search-rest-api';
import { CompanyEmployeesApiFactory } from '@/api/generated/apis/company-employees-api';
import { CompanyEmployeesSearchRestApiFactory } from '@/api/generated/apis/company-employees-search-rest-api';
import { CompanyObserversApiFactory } from '@/api/generated/apis/company-observers-api';
import { type Configuration } from '@/api/generated/configuration.ts';
import CONFIG from '@/config/config';

import { useAxiosInstance } from './useAxiosInstance.util';

interface Return {
  companiesApi: ReturnType<typeof CompaniesApiFactory>;
  companiesSearchApi: ReturnType<typeof CompaniesSearchRestApiFactory>;
  companyEmployeesApi: ReturnType<typeof CompanyEmployeesApiFactory>;
  companyEmployeesSearchApi: ReturnType<typeof CompanyEmployeesSearchRestApiFactory>;
  companyObserversApi: ReturnType<typeof CompanyObserversApiFactory>;
}

export const useCompanyApiClient = (): Return => {
  const basePath = CONFIG.HOST;
  const configuration = getConfiguration(basePath);
  const axiosInstance = useAxiosInstance();

  return useMemo(() => {
    return {
      companiesApi: CompaniesApiFactory(configuration, undefined, axiosInstance),
      companiesSearchApi: CompaniesSearchRestApiFactory(configuration, undefined, axiosInstance),
      companyEmployeesApi: CompanyEmployeesApiFactory(configuration, undefined, axiosInstance),
      companyEmployeesSearchApi: CompanyEmployeesSearchRestApiFactory(
        configuration,
        undefined,
        axiosInstance,
      ),
      companyObserversApi: CompanyObserversApiFactory(configuration, undefined, axiosInstance),
    };
  }, [axiosInstance, configuration]);
};

const getConfiguration = (basePath: string): Configuration => ({
  basePath,
  isJsonMime(_mime: string): boolean {
    return true;
  },
});
